// extracted by mini-css-extract-plugin
export default {"title":"BenefitsModal_title__-OfjW","benefits":"BenefitsModal_benefits__fW3by","benefit":"BenefitsModal_benefit__C-tVh","content":"BenefitsModal_content__nYXuP"};